/** `/preview` itself, or anything below it; query and fragment do not count as part of the path. */
const PREVIEW_PATH = /^\/preview(?:[/?#]|$)/;

/** Whether a router URL or a location pathname belongs to the admin-driven `/preview/*` pages. */
export const isPreviewPath = (path: string): boolean => PREVIEW_PATH.test(path);

/**
 * Whether this document was opened on `/preview/*`. Read at bootstrap, before the router exists:
 * the preview document must not start analytics or plan sync (it shares `localStorage` with the
 * portal and must make no `/api` requests).
 */
export const isPreviewDocument = (): boolean =>
  typeof location !== 'undefined' && isPreviewPath(location.pathname);
